export const USER_ROLE = {
    CUSTOMER: 0,
    ADMIN: 1,
    HOST: 2,
    SALES: 3,
};
export const INTERNAL_ORDER_TYPE = {
    OUT: 0,
    IN: 1,
};

export const PRODUCT_TYPE = {
    SUPPLY_CENTER_ORDER: 1,
    TFS_ORDER: 2,
};

export const PRODUCT_SOURCE = {
    OEM: 'OEM',
};

export const APPLY_QUOTE_TYPE = {
    M_QUOTE: 'M',
    R_QUOTE: 'R',
};

export const APPLY_QUOTE_ERROR_CODE = {
    E1PQ40: 'E1PQ40',
    E1PQ35: 'E1PQ35',
};

export const NO_SUPPLY_CENTER_ID = -1;

export const SHIPMENT_SORT = {
    ASC_SORT: 'asc',
    DESC_SORT: 'desc',
};

export const base64ShippingImage =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAKlBMVEVHcEwpc7opc7opc7opc7opc7opc7opc7opc7opc7opc7opc7opc7opc7p92vPhAAAADXRSTlMASJs5vHcUJNrrg2D5MkoXXgAAAKJJREFUKJHdUFkWAyEIExncuf91G0B9bW/Q5mPGEMKW0p+hEpWPABPvlywFmsmzWVCMK5nWNJBRAb+j6QPtsThR7sjMeM/kLpYSybdfGFT75kNVjjYhoS769IiB1SMu2JaOekZ4FzEIW6VUH5eLzSC3Y/cvPGW4l+9AzYzul0htd5Wxoo0n5VokFj1HcGLom/PeBujzXjY7p3N45u/Df/KfxwtfKQhtM61VrwAAAABJRU5ErkJggg==';

export const PURCHASE_ORDER_MODE = {
    ONLINE: 'Online',
    OFFLINE: 'Offline',
};

export const PURCHASE_ORDER = {
    TIMER: 10,
};

export const UPLOAD_FILE_LIMIT = {
    FILE_LIMIT: 'file_upload_limit',
};

export const MY_ORDER_STATUS = {
    ONHOLD: 2,
};

export const ORDER_TYPE = {
    SCM: 'SCM',
    TFS: 'TFS',
};

export const OrderTypeEnum = {
    SO: 'SO',
    SE: 'SE',
};

export const BT_TYPE = {
    DEALER: 'Dealer',
};

export const FROM_PAGE = {
    fromShipEditPage: 'shipEdit',
};

export const F1_PACKAGE_SORT = {
    ASC_SORT: 'asc',
    DESC_SORT: 'desc',
};

export const QUESTION_TYPE = {
    MULTIPLE: 'multiple',
    SINGLE: 'single',
    GQP_FILLING: 'gap_filling',
};

export const TASK_STATUS = {
    PROGRESS: 'progress',
    SUBMITTED: 'submitted',
    COMPLETED: 'completed',
};

export const TAB_FLAG = {
    TO_BE_COMPLETED: 1,
    FOLLOW_UP: 2,
    ALL_COMPLETED: 3,
};

export const cusotmerInfo = [
    {
        contact: '王安娜',
        positionName: '老师',
        closeness: '熟悉',
    },
    {
        contact: '张三',
        positionName: '老师',
        closeness: '不熟悉',
    },
    {
        contact: '宋晓晓',
        positionName: '快递员',
        closeness: '不熟悉熟悉',
    },
];

export const RECEIVE_METHOD = {
    CUSTOMER: 'customer',
    DELEGATE: 'delegate',
};

export const PROXY_DELIVERY_ORDER_PACKAGE_SORT = {
    ASC_SORT: 'asc',
    DESC_SORT: 'desc',
};

export const PROXY_DELIVERY_ORDER_TAB_FLAG = {
    In_TRANSIT_PACKAGE: 3,
    WAIT_FOR_RECEIVING: 1,
    COMPLETED_PACKAGE: 2,
};

export const PROXY_DELIVERY_RECEIVE_TYPE = {
    HOST: 'HOST',
    CUSTOMER: 'CUSTOMER',
};

export const PROXY_DELIVERY_ORDER_STATUS = {
    IN_TRANSIT: 'IN_TRANSIT',
    WAIT_CUSTOMER_RECEIPT: 'WAIT_CUSTOMER_RECEIPT',
    CUSTOMER_REJECTED: 'CUSTOMER_REJECTED',
    HOST_REJECTED: 'HOST_REJECTED',
    COMPLETED: 'COMPLETED',
};
